module.exports = __webpack_public_path__ + "static/media/tenant1-2.6dcb942c.png";